import React, { useLayoutEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Tooltip } from 'react-tooltip';
import TimesheetRow from './TimesheetRow';
import { addBlankTimeEntryRow, addBlankTimeOffRow } from './timesheetSlice';
import { t } from 'i18next';
import { getValueFromResource } from '../../common/timeLiveFunction';

const TimesheetTableSectionOne = () => {
  const state = useAppSelector((state) => state.timesheet);
  const { timeEntryViewType, isLocked, timeEntriesList, IsMyTimeOff } = state;
  const { showTimeOffInTimesheet, cultureInfoName } = useAppSelector((state) => state.globalState);
  const dispatch = useAppDispatch();
  const addTimeItemRow = (e: any) => {
    dispatch(addBlankTimeEntryRow());
  }
  const addTimeOffRow = (e: any) => {
    dispatch(addBlankTimeOffRow());
  }

  return (
    <div id="section-one" className={"datePanel selectionTableCol"} style={{ width: timeEntryViewType == 'Daily' ? 1050 : 550, maxWidth: timeEntryViewType == 'Daily' ? 1030 : 530, borderTopLeftRadius: '0.3rem' }}>
      <table id="tblSelection" className={"table data-table time-entry-table"}>
        <thead>
          <tr>
            <th className='tsSectionOneThead'>
              <div className={"empty-TableSelectionRow"} style={{ marginBottom: 10, marginLeft: 0 }}>
                <span data-tooltip-id="my-tooltip-styles"
                  data-tooltip-place="right"
                  data-tooltip-content=
                  // {'Add Time Item Row'}
                  {getValueFromResource('Add Time Item Row', dispatch, t)}>
                  <a onClick={isLocked ? undefined : (e) => { addTimeItemRow(e) }} className='tsTextHeading'>
                    <i className="ki-duotone ki-plus fs-4 addNewItemRow">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                  </a>
                </span>
                <a className={"timeOffHeadingRow"} >
                 
                  {getValueFromResource('Timesheet', dispatch, t)}
                </a>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {timeEntriesList.map((x: any, i) =>
            x.isTimeOff != true &&
            <TimesheetRow
              key={i}
              rowId={x.rowId}
            />
          )}
          
 
{IsMyTimeOff && showTimeOffInTimesheet && (
  <tr>
    <td style={{ borderLeftStyle: 'hidden', borderRightStyle: 'hidden', borderBottom: '1px solid #eff2f5', padding: 0, fontSize: 0, lineHeight: 0 }}>
      <div style={{ height: '15px' }}></div> {/* Is height ko aap apni marzi se 10px ya 20px jitna chahein kam/zyada kar sakte hain */}
    </td>
  </tr>
)}
          {/* {IsMyTimeOff && showTimeOffInTimesheet && <tr className={"timesheet-row"}>
            <td style={{ height: 74, borderRightStyle: 'hidden', borderLeftStyle: 'hidden' }}>
              <div className='tsTimeOffDiv'>
                <div style={{ paddingTop: 16, textAlign: 'left', marginLeft: 10 }}>
                  <span data-tooltip-id="my-tooltip-styles"
                    data-tooltip-place="right"
                    data-tooltip-content=
                  
                    {getValueFromResource('Add Time Off Row', dispatch, t)}>
                    <a onClick={isLocked ? undefined : (e) => { addTimeOffRow(e) }} className='tsTextHeading'>
                      <i className="ki-duotone ki-plus fs-4 addNewItemRow" style={{ marginTop: 1.5 }}>
                        <span className="path1"></span>
                        <span className="path2"></span>
                      </i>
                    </a>
                  </span>
                  <a className={"timeOffHeadingRow"} >
                
                    {getValueFromResource('Time Off', dispatch, t)}

                  </a>
                </div>
              </div>
            </td>
          </tr>} */}
          {IsMyTimeOff && showTimeOffInTimesheet && <tr className={"timesheet-row"}>
          <td style={{ height: 74, borderRightStyle: 'hidden', borderLeftStyle: 'hidden' }}>
    <div className='tsTimeOffDiv'>
      <div style={{ paddingTop: 16, textAlign: 'left', marginLeft: 10, display: 'flex', alignItems: 'center', gap: '10px' }}>
        
      <a className={"timeOffHeadingRow"} style={{ marginRight: '5px' }}>
          {getValueFromResource('Time Off', dispatch, t)}
        </a>       
        <span 
          data-tooltip-id="timeoff-viewonly-tooltip"
          style={{
            backgroundColor: '#f1f1f4',
            color: '#7e8299',
            fontSize: '11px',
            fontWeight: '600',
            padding: '4px 10px',
            borderRadius: '20px',
            display: 'inline-flex',
            alignItems: 'center',
            cursor: 'pointer'
          }}
        >
          View Only
        </span>

      </div>
    </div>
  </td>
  </tr>} 
          {IsMyTimeOff && showTimeOffInTimesheet && timeEntriesList.map((x: any, i) =>
            x.isTimeOff &&
            <TimesheetRow
              key={i}
              rowId={x.rowId}  
              isReadOnly={true}        
            />
          )}
       
{IsMyTimeOff && showTimeOffInTimesheet && !timeEntriesList.some((x: any) => x.isTimeOff) && (
  <tr style={{ height: '45px' }}>
    <td style={{ borderRightStyle: 'hidden', borderLeftStyle: 'hidden', padding: 0, backgroundColor: '#ffffff' }}>
      <div style={{ height: '45px' }}></div>
    </td>
  </tr>
)}
        </tbody>
        <tfoot>
          <tr className={"timesheet-row"}>
            <td style={{ borderRightStyle: 'hidden', borderLeftStyle: 'hidden' }}>
              <div className={"empty-TableSelectionRow"} style={{ marginLeft: -3, marginTop: 5 }}>
                <span className={"timeOffHeadingRow"}>
                  {/* {t('Total')} */}
                  {getValueFromResource('Total', dispatch, t)}

                </span>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
      
     
      <Tooltip id="my-tooltip-styles" style={{ fontSize: 12, fontWeight: 600 }} />
      
     
      <Tooltip 
        id="timeoff-viewonly-tooltip" 
        clickable 
        style={{ fontSize: 12, fontWeight: 500, backgroundColor: '#1e1e2d', color: '#fff', padding: '8px 12px', borderRadius: '4px', maxWidth: '300px' }}
      >
    <span> This is a view-only area. Please submit all time off requests through the 
    <a href="/timeoffrequest" target="_blank" rel="noopener noreferrer" style={{ color: '#3598db', textDecoration: 'underline', marginLeft: '4px', fontWeight: '600' }}>
      Time Off
    </a> menu.
  </span>
      </Tooltip>
    </div>
  )
}

export default TimesheetTableSectionOne